import TenantsPage from "./TenantsPage";

export default TenantsPage;
